import { isFormThemeRootVolumeEntry } from "../client-form-theme-elfinder-helper.js";

/**
 * Creates new ELFinder command for the client form theme menu. This command lets the user
 * edit the selected form theme. This is the same as the "info" command, but with a different
 * icon and title.
 *
 * This command is enabled when exactly one form theme root is selected.
 * @returns The new ELFinder command.
 */
export function createEditThemeCommand(): elFinder.ElFinderCommandHandlerBaseStatic<elFinder.BaseElFinderCommandOptions> {
  const command: elFinder.ElFinderCommandHandlerBaseStatic<elFinder.BaseElFinderCommandOptions> = function () {
    this.getstate = function (targets) {
      const files = this.files(targets);
      if (files.length === 1 && isFormThemeRootVolumeEntry(files[0])) {
        return 1;
      } else {
        return -1;
      }
    };

    this.init = function (this: elFinder.ElFinderCommandHandlerBase<elFinder.BaseElFinderCommandOptions>) {
      this.className = "edit-theme";
      this.title = this.fm.i18n("editTheme");
      this.name = "editTheme";
    };

    this.exec = function (hashes, data) {
      return this.fm.exec("info", hashes, data);
    };
  };

  return command;
}
